// >0:开启调试打印
let debug = 0;

// 储存命名域
let storePrefix = '';

// 当前系统语言(默认中文)
let language = 'zh-CN';

// api接口
let rootUrl = '';
let rootKey = '';

// 文件接口
let fileUrl = '';
let fileKey = '';

// ws接口
let wsUrl = '';
let wsKey = '';

// 常用变量
let appId = ''; //
let modelLogin = 'user'; // 默认从用户模块登录
let modelLoginStaff = 'user-admin'; // 默认从用户模块登录
let defaultAvatar = ''; // 默认头像

// 应用实例
let app = null;

// 错误捕捉
let errorHandler = null;
let errorHandlerToken = null; // token错误捕捉

// 初始化回调
let hookInitialHandlerToken = []; //
let hookInitialHandlerTokenUnique = {}; //

// debug
const setDebug = v => {
    debug = v;
};

// debug
const getDebug = v => debug;

// language
const setLanguage = v => {
    language = v;
};

// language
const getLanguage = v => language;

// 储存命名域
const setStorePrefix = v => {
    if (v && v.includes('-')) {
        storePrefix = v;
    } else if (v) {
        storePrefix = v + '-';
    } else {
        storePrefix = v;
    }
};

// api接口
const setRootUrl = v => {
    rootUrl = v;
    if (!fileUrl) {
        fileUrl = v;
    }
};

// api接口
const setRootKey = v => {
    rootKey = v;
    if (!fileKey) {
        fileKey = v;
    }
    if (!storePrefix) {
        setStorePrefix(v);
    }
};

// ws接口
const setWsUrl = v => {
    wsUrl = v;
};
const setWsKey = v => {
    wsKey = v;
};

// 文件接口
const setFileUrl = v => {
    fileUrl = v;
};

// 文件接口
const setFileKey = v => {
    fileKey = v;
};

// 小程序appId
const setAppId = v => {
    appId = v;
};

const getAppId = v => appId;

// 储存前缀
const getStorePrefix = () => `${storePrefix}`;

// token
const getStoreToken = () => `${storePrefix}token`;

// uid
const getStoreUid = () => `${storePrefix}uid`;

// openId
const getStoreOpenId = () => `${storePrefix}openId`;

// staff
const getStoreStaff = () => `${storePrefix}staff`;

// 重新登录
const getStoreUrl = () => `${storePrefix}before`;

// graphql 入口地址
const getGqlNetworkInterface = () => `${rootUrl}/api/${rootKey}/graphql`;

// ws入口地址
const getWsInterface = () => {
    return `${wsUrl ? wsUrl : rootUrl.replace('http', 'ws')}/api/${wsKey ? wsKey : rootKey}/ws`;
};

// 图片上传地址
const getImgUploadPath = () => {
    return `${fileUrl ? fileUrl : rootUrl}/api/${fileKey ? fileKey : rootKey}/filepool/upload-image`;
};

// 文件上传地址
const getFileUploadPath = () => {
    return `${fileUrl ? fileUrl : rootUrl}/api/${fileKey ? fileKey : rootKey}/filepool/upload-file`;
};

// 图片原图地址
const getImgPath = () => {
    return `${fileUrl ? fileUrl : rootUrl}/api/${fileKey ? fileKey : rootKey}/filepool/download/images/`;
};

// 图片缩略图地址
const getImgThumbPath = () => {
    return `${fileUrl ? fileUrl : rootUrl}/api/${fileKey ? fileKey : rootKey}/filepool/download/thumbnail/`;
};

// 文件下载地址
const getFilePath = () => {
    return `${fileUrl ? fileUrl : rootUrl}/api/${fileKey ? fileKey : rootKey}/filepool/download/files/`;
};

// 图片验证码地址
const getCaptchaTagPath = () => `${rootUrl}/api/${rootKey}/user/captcha/`;

// 其它配置
let copyright = ''; // 底部版权信息
let loginUrl = ''; // 登录url

// 添加hook isPrepend:添加到优先执行
const addInitialHandlerToken = (fn, isPrepend = false) => {
    if (fn && {}.toString.call(fn) === '[object Function]' && !hookInitialHandlerTokenUnique[fn]) {
        hookInitialHandlerTokenUnique[fn] = 1;
        if (isPrepend === true) {
            hookInitialHandlerToken.unshift(fn);
        } else {
            hookInitialHandlerToken.push(fn);
        }
    }
};

// 触发hook
const doInitialHandlerToken = token => {
    for (let i = 0; i < hookInitialHandlerToken.length; i++) {
        hookInitialHandlerToken[i](token);
    }
};

// 取所有配置
const getAll = () => {
    return {
        debug: getDebug(),
        language: getLanguage(),
        storePrefix: getStorePrefix(),
        storeToken: getStoreToken(),
        gqlNetworkInterface: getGqlNetworkInterface(),
        getWsInterface: getWsInterface(),
        imgUploadPath: getImgUploadPath(),
        fileUploadPath: getFileUploadPath(),
        imgPath: getImgPath(),
        imgThumbPath: getImgThumbPath(),
        filePath: getFilePath(),
        captchaTagPath: getCaptchaTagPath(),
        copyright: copyright,
    };
};

//
export default {
    appId,
    modelLogin,
    modelLoginStaff,
    defaultAvatar,
    //
    app,
    errorHandler,
    errorHandlerToken,
    // hook
    addInitialHandlerToken,
    doInitialHandlerToken,
    //
    setDebug,
    setLanguage,
    setStorePrefix,
    setRootUrl,
    setRootKey,
    setWsUrl,
    setWsKey,
    setFileUrl,
    setFileKey,
    setAppId,
    //
    getDebug,
    getLanguage,
    getStorePrefix,
    getStoreToken,
    getStoreUid,
    getStoreOpenId,
    getStoreStaff,
    getStoreUrl,
    getAppId,
    //
    getGqlNetworkInterface,
    getWsInterface,
    getImgUploadPath,
    getFileUploadPath,
    getImgPath,
    getImgThumbPath,
    getFilePath,
    getCaptchaTagPath,
    //
    copyright,
    loginUrl,
    //
    getAll,
};
